import Link from 'next/link';

import { useBusiness } from 'hooks/business/useBusiness';

import { HeroImage } from '../HeroImage/HeroImage';
import { PlayfulNavigation } from './PlayfulNavigation';

import s from './PlayHeroNavigation.module.css';

export const PlayHeroNavigation = () => {
  const { name } = useBusiness();

  return (
    <div className={s.container}>
      <div className={s.navContainer}>
        <PlayfulNavigation />
      </div>
      <div className={s.heroContainer}>
        <HeroImage />
        <h1>
          <Link href="/">{name}</Link>
        </h1>
      </div>
    </div>
  );
};
